import { TradingPartner } from 'common/types/kraken-core/TradingPartner'
import { Box, InputLabel, Stack, TextField } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { Button } from '@loadsmart/loadsmart-ui'
import { updateTradingPartner } from 'services/kraken-core/trading_partner/tradingPartner.service'
import { toast } from 'react-toastify'
import Editor from '@monaco-editor/react'

export interface TradingPartnerDetailsProps {
  tradingPartner: TradingPartner
}

export function TradingPartnerDetails({ tradingPartner }: TradingPartnerDetailsProps) {
  const [data, setData] = useState<TradingPartner>(tradingPartner)
  const [isModified, setIsModified] = useState(false)

  function updateField(field: string, value: string) {
    setData({ ...data, [field]: value })
  }

  function onSave() {
    if (!data.id) {
      return
    }

    updateTradingPartner(data)
      .then(response => {
        setData(response)
        toast.success('Trading partner updated successfully')
      })
      .catch(error => {
        toast.error(`Error updating trading partner: ${error.message}`)
      })
  }

  const MetadataEditor = () =>
    useMemo(() => {
      return (
        <Editor
          value={JSON.stringify(data?.metadata, null, 2)}
          language="application/json"
          options={{}}
          height={'30vh'}
          onChange={value => {
            try {
              if (value) {
                const parsedValue = JSON.parse(value)
                updateField('metadata', parsedValue)
              }
            } catch (error) {
              console.error('Error parsing JSON:', error)
            }
          }}
        />
      )
    }, [data])

  useEffect(() => {
    setData(tradingPartner)
  }, [tradingPartner])

  useEffect(() => {
    JSON.stringify(data) !== JSON.stringify(tradingPartner)
      ? setIsModified(true)
      : setIsModified(false)
  }, [data])

  return (
    <Stack spacing={2}>
      <Box justifyContent={'end'} justifyItems={'end'} display={'flex'}>
        <Button variant="primary" onClick={onSave} disabled={!isModified}>
          Save
        </Button>
      </Box>

      <Stack spacing={2}>
        <TextField
          label="Code"
          variant="filled"
          size="small"
          value={data?.code}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={e => updateField('code', e.target.value)}
        />

        <Stack spacing={2}>
          <InputLabel shrink={true} variant="filled">
            Metadata
          </InputLabel>
          {MetadataEditor()}
        </Stack>
      </Stack>
    </Stack>
  )
}
